$(document).ready(function() {
    $('.reupload-file').click(function() {
        $(this).closest('.file-exists').removeClass('file-exists');
    });
});